import Helper from '@/resources/Helper';
import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'inspection';

const functions = {
    async get() {
        await this.sync();
        
        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncDataVersion(tableName);
    },
    async getDetail(key) {
        const currentData = await this.get();
        
        return await DBEngine.getContentDetailByKey(currentData, key);
    },
    async save(value) {
        const currentData = await this.get();
        let isUpdate = false;

        // Stamp Update Time
		value['timestamp'] = Helper.getClientTime();

        // Check Existing
        for (let index = 0; index < currentData.content.length; index++) {
            if (currentData.content[index].key === value.key) {
                currentData.content[index] = value;
                isUpdate = true;
                break;
            }
        }

        // New Inspection
        if (!isUpdate) {
            currentData.content.push(value);
        }

		// Setup Current IndexedDB
		await DBEngine.replaceRecord(tableName, currentData.content, currentData.version);

		// Sync Pipeline
		SyncEngine.setupSyncPipeline(tableName, isUpdate ? DBEngine.syncAction().update : DBEngine.syncAction().add, value);

		return value;
    },
    async delete(item) {
        const currentData = await this.get();

        await DBEngine.updateListData(tableName, currentData, item, DBEngine.syncAction().delete);
    }
}

export default functions;